import React from 'react'


export const SideBar = (props) => {
    return (
        <div className="fixed h-5/6 w-fit bg-gray-200">
        </div>
    );
}
